import React, { useState } from 'react';
import styled from 'styled-components';
import { string, any, func, number, bool, oneOfType, object, array } from 'prop-types';
import { Row, Column } from '../Grid';

const AccordionContainer = styled.div`
    background-color: ${({ background = '#ffffff' }) => background};
    width: 100%;
    min-height: 38px;
    border-top: 1px solid #eaeaea;
`;

const AccordionChildrenContainer = styled.div`
  margin: 0px;
`;

const AccordionHeader = ({
    title,
    onClick,
    opened,
    margin,
    background,
    iconOpened,
    iconClosed,
    iconPosition,
    iconSize,
    iconOpenedColor,
    iconClosedColor,
    rightHeader,
    styleHeader
}) => {
    const iconPositions = {
        right: 'flex-end',
        center: 'center',
        left: 'flex-start'
    };
    const flexByIconPosition = position => iconPosition === position ? 20 : 'none';
    return (
        <Row style={{ cursor: 'pointer', padding: `10px ${margin}px`, background: background || 'white', ...styleHeader }} onClick={onClick}>
            <Column>
                <Row>
                    <Column justify='center' flex={flexByIconPosition('right')}>
                        { title }
                    </Column>
                    {
                        rightHeader && (
                            <Column justify='center' align='flex-start'>
                                { rightHeader }
                            </Column>
                        )
                    }
                </Row>
            </Column>
            <Column align={iconPositions[iconPosition]} justify='center' flex={flexByIconPosition('left')} pL={10}>
                <span
                    className={`icon-ic-${opened ? iconOpened : iconClosed}`}
                    style={{ color: opened ? iconOpenedColor : iconClosedColor, fontSize: iconSize }}
                />
            </Column>
        </Row>
    );
};

AccordionHeader.propTypes = {
    title: oneOfType([string, object]),
    onClick: func,
    opened: bool,
    margin: number,
    background: string,
    iconOpened: string,
    iconClosed: string,
    iconPosition: string,
    iconSize: number,
    iconOpenedColor: string,
    iconClosedColor: string,
    rightHeader: oneOfType([array, object]),
    styleHeader: object
};

AccordionHeader.defaultProps = {
    iconOpened: 'minus',
    iconClosed: 'plus',
    iconPosition: 'right',
    iconSize: 14,
    iconOpenedColor: '#848484',
    iconClosedColor: '#4cb358',
    rightHeader: null
};

const Accordion = ({
    defaultOpened,
    children,
    background,
    backgroundHeader,
    fixedBackgroundHeader,
    style,
    ...props
}) => {
    const [opened, setOpened] = useState(defaultOpened);
    return (
        <AccordionContainer background={opened ? background : 'white'} style={{ ...style }}>
            <AccordionHeader
                background={opened || fixedBackgroundHeader ? backgroundHeader : 'white'}
                onClick={() => setOpened(!opened)}
                opened={opened}
                {...props}
            />
            <AccordionChildrenContainer>
                { opened && children }
            </AccordionChildrenContainer>
        </AccordionContainer>
    );
};

Accordion.propTypes = {
    title: oneOfType([string, object]),
    children: any,
    defaultOpened: oneOfType([bool, number]),
    background: string,
    backgroundHeader: string,
    fixedBackgroundHeader: bool,
    style: object
};

Accordion.defaultProps = {
    defaultOpened: false,
    title: '',
    margin: 10,
    fixedBackgroundHeader: false
};

export default Accordion;
